import { useState } from 'react';
import styled from 'styled-components';

import { Flex, Space } from '@/components/base';
import Button from '@/components/Button/Button';
import Heading from '@/components/Typography/Heading';
import Typo from '@/components/Typography/Typo';
import useColor from '@/hooks/domain/useColor';
import { modalStyle } from '@/styles/style';

const SlackIntegrationInfoModal = () => {
  const color = useColor();
  const [step, setStep] = useState(0);

  return (
    <InfoModalStyle d="column">
      <Heading type="h2">Simple way to push feedback into your inbox.</Heading>
      <Space h="32px" />
      <Typo type="label2" weight="sb">
        1. Download and add to your slack workspace
      </Typo>
      <Space h="4px" />
      <IndentWrapper>
        <Typo type="body2">
          This emoji triggers the push action.
          <br />
          Make sure to maintain the emoji name <strong>:push_syncly:</strong> as
          this is the magic word!
        </Typo>
        <Space h="16px" />
        <Flex g="16px" a="flex-end">
          <img
            src="/assets/push_syncly.png"
            width={48}
            height={48}
            alt="push_syncly"
          />
          <a href="/assets/push_syncly.png" download>
            <Button
              variant={step === 0 ? 'primary' : 'outlined'}
              onClick={() => {
                setStep(1);
              }}
            >
              Download
            </Button>
          </a>
        </Flex>
      </IndentWrapper>
      {step === 1 && (
        <>
          <Space h="32px" />
          <Typo type="label2" weight="sb">
            2. Add it to your workspace
          </Typo>
          <Space h="4px" />
          <IndentWrapper>
            <Typo
              type="body2"
              color={color.primary100}
              style={{ textDecoration: 'underline' }}
            >
              <a
                href={import.meta.env.VITE_PUBLIC_ADD_EMOJI_TO_SLACK_URL}
                target="_blank"
                rel="noreferrer"
              >
                How to add emoji to slack
              </a>
            </Typo>
          </IndentWrapper>
        </>
      )}
    </InfoModalStyle>
  );
};

const InfoModalStyle = styled(Flex)`
  width: 620px;
  padding: 32px;
  ${modalStyle};
`;

const IndentWrapper = styled.div`
  padding-left: 16px;
`;

export default SlackIntegrationInfoModal;
